export type { CaptchaProps } from './Captcha'
export { default } from './Captcha'
